export default __webpack_public_path__ + "static/media/img_step_lucia06_w.62062f42.jpg";